// helpers
import { ifElse, isAllTrue } from './helpers';
//////////////////////////////////////////////////

// helper for getting react component display name
const getDisplayName = (WrappedComponent) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component';

const getComponentCountTimes = (count = 0, renderFunc) => {
  const arr = new Array(count).fill();

  return arr.map(renderFunc);
};

const renderIfAll = (component, ...conditions) => ifElse(
  isAllTrue(...conditions),
  component,
  null,
);

export {
  renderIfAll,
  getDisplayName,
  getComponentCountTimes,
};
